// Pareja de horas de un servicio (inicio y fin): misma regla que el servidor
// (horarios_servicios.error_franja). Un servicio no cruza la medianoche salvo
// los de noche: empieza desde las 18:00 y acaba a las 06:00 como tarde (cena o
// barra libre hasta las 02:00). Fin igual a inicio, o anterior fuera de ese
// caso, es un error: los controles no guardan mientras la pareja no vale.

const CRUCE_MEDIANOCHE_DESDE = 18 * 60;
const CRUCE_MEDIANOCHE_HASTA = 6 * 60;

export const TEXTO_FIN_ANTES = 'Fin antes que inicio';
export const TEXTO_FIN_IGUAL = 'Fin igual que inicio';

const minutos = (valor) => {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(valor || '').trim());
  if (!m) return null;
  const h = Number(m[1]);
  const mi = Number(m[2]);
  if (h > 23 || mi > 59) return null;
  return h * 60 + mi;
};

// Texto del error de la pareja o null si vale (o si falta alguna de las dos)
export const errorFranja = (inicio, fin) => {
  const a = minutos(inicio);
  const b = minutos(fin);
  if (a === null || b === null) return null;
  if (a === b) return TEXTO_FIN_IGUAL;
  if (b < a && !(a >= CRUCE_MEDIANOCHE_DESDE && b <= CRUCE_MEDIANOCHE_HASTA)) return TEXTO_FIN_ANTES;
  return null;
};

// Clase del texto del error (rojo, junto a las horas)
export const CLASE_ERROR_FRANJA = 'text-[11px] font-semibold text-red-700';

const DIA = 24 * 60;
const hhmm = (m) => {
  const v = ((m % DIA) + DIA) % DIA;
  return `${String(Math.floor(v / 60)).padStart(2, '0')}:${String(v % 60).padStart(2, '0')}`;
};

// F6: aviso (no bloqueo) si el servicio de `inicio` a `fin` se sale del
// horario de su día o del evento (`refInicio` a `refFin`). Misma regla que el
// servidor (horarios_servicios.fuera_de_horario). Sin fin del día (o igual al
// inicio: fin sin definir) solo se mira el inicio. Texto o null.
export const fueraDeHorario = (inicio, fin, refInicio, refFin, que = 'evento') => {
  let a = minutos(inicio);
  let b = minutos(fin);
  const ri = minutos(refInicio);
  let rf = minutos(refFin);
  if (a === null || ri === null) return null;
  if (rf !== null && rf === ri) rf = null;
  if (rf !== null && rf < ri) rf += DIA;
  if (ri - a > DIA / 2) a += DIA;
  if (b !== null) {
    if (a >= DIA) b += DIA;
    while (b <= a) b += DIA;
  }
  const fuera = a < ri || (rf !== null && (a >= rf || (b !== null && b > rf)));
  if (!fuera) return null;
  const rango = rf !== null ? `${hhmm(ri)} a ${hhmm(rf)}` : `desde las ${hhmm(ri)}`;
  return `Fuera del horario del ${que} (${rango})`;
};

// Horario de referencia de una jornada (la suya o, sin hora, la del evento)
export const horarioReferenciaJornada = (jornada, presupuesto) => (jornada?.hora_inicio
  ? [jornada.hora_inicio, jornada.hora_fin || '']
  : [presupuesto?.hora_inicio || '', presupuesto?.hora_fin || '']);

// "09:00 a 10:00", "09:00 (sin hora de fin)" o "sin hora"
export const textoHorasServicio = (inicio, fin) => {
  if (inicio && fin) return `${inicio} a ${fin}`;
  if (inicio) return `${inicio} (sin hora de fin)`;
  if (fin) return `? a ${fin}`;
  return 'sin hora';
};
